import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Form from 'react-jsonschema-form';
import { Button } from 'react-bootstrap';
import { getFormPackSchema, getUiSchema } from './Schema';

export default class FormPackEditor extends PureComponent {
  onSubmit = ({ formData }) => {
    const { type } = this.props;
    this.props.onUpdate({ ...formData, type });
  };

  render() {
    const { fetching, forms, formPack, type } = this.props;
    return (
      <div className="form-list-container">
        <Form
          schema={getFormPackSchema(formPack, forms, type)}
          uiSchema={getUiSchema(type)}
          formData={formPack}
          onSubmit={this.onSubmit}
          enctype="multipart/form-data"
        >
          <Button
            bsClass="btn btn-primary btn-large"
            disabled={fetching}
            type="submit"
          >
            Save
          </Button>
        </Form>
      </div>
    );
  }
}

FormPackEditor.propTypes = {
  fetching: PropTypes.bool,
  formPack: PropTypes.object,
  forms: PropTypes.array,
  onUpdate: PropTypes.func,
  type: PropTypes.string,
};
